import {useDockConfig} from './DockContext';

export interface DockSeparatorProps {
  /** Thickness of the hairline, in px. */
  thickness?: number;
}

/**
 * A non-scaling layout child that doubles as a REORDER BOUNDARY.
 *
 * Separators are invisible to the magnification pass (they have no scale) and
 * they split the item list into blocks: an item may be reordered freely inside
 * its own block, but dragging it across a separator is treated as an invalid
 * drop and snaps back. That is how macOS keeps Trash pinned to the right.
 */
export function DockSeparator({thickness = 1}: DockSeparatorProps) {
  const {direction, size} = useDockConfig();
  const style =
    direction === 'horizontal'
      ? {height: `${size}px`, width: `${thickness}px`}
      : {height: `${thickness}px`, width: `${size}px`};

  return (
    <li
      data-dock-separator=""
      className={`dock-separator dock-separator--${direction}`}
      role="separator"
      aria-orientation={direction === 'horizontal' ? 'vertical' : 'horizontal'}
      style={style}
    >
      <span className="dock-separator__line" />
    </li>
  );
}
